export default class StoreProcedureNodeConst {
    static VAR_PARAM_IN='variableParametersInput';
    static VAR_CONN_IN='variableConnectionInput';
    static VAR_PROC_IN='variableProcNameInput';
    
  }